import { NEWS_LETTER_BLOCK_ID, GALLARY_EXPLORE_BLOCK_ID, CONTACT_US_BLOCK_ID, SOCIAL_MEDIA_BLOCK_ID, CONTACT_US, SUPPORT, SITE_MAP, PRIVACY_POLICY, TERMS_CONDITION, TERMS_OF_USE, GIVEPLEASE_MICROSITE } from "../../common/constant";
import React, { Suspense, lazy } from 'react';
import { COMPANY_NAME_FULL } from '../../common/';
import FleckringFooter from './fleckring-footer';
import PageContext from '../../context';
import { history } from "../../jwt/_helpers";
import { Common } from "../../common/common";
import moment from "moment";
import { LOGO_GIVEPLEASE } from "../../assets/images/icon-svg";
import { EMAIL_IMG, TEL_IMG } from "../../common/images-s3";

const ImageLoader = lazy(() => import('../../common/image-loader'));


class FooterSection extends React.Component {
    static contextType = PageContext;
    constructor(props) {
        super(props);
        this.state = {
            conactDetails: null,
            newsLetterSettings: null,
            settings: [],
            gallaryBlock: null,
            gallarySetting: null,
            contactUsBlock: null,
            socialMediaBlock: null,
            socialMediaIcon: null,
            year: moment().format('YYYY')
        };
    }

    componentDidMount() {
        const context = this.context;

        const contactBlock = context.blockDetails.filter((details) => details.blockId === CONTACT_US_BLOCK_ID);
        const socialMediaBlock = context.blockDetails.filter((details) => details.blockId === SOCIAL_MEDIA_BLOCK_ID);

        this.setState({
            conactDetails: context.conactDetails ?? null,
            contactUsBlock: contactBlock[0],
            socialMediaBlock: socialMediaBlock[0],
            socialMediaIcon: context.socialMediaIcon
        })
    }

    render() {
        return (
            <>
                {
                    this.state.conactDetails ?
                        <div id="CONTACT" className="sec-footer">
                            <div className="container">
                                {this.state.conactDetails ?
                                    <div className="row c-sitemap-copyright">
                                        <div className="col-xs-12 col-sm-9 col-md-10 c-contact-social">
                                            <div className="c-contact">
                                                {this.state.conactDetails && this.state.conactDetails.contactNumber ?
                                                    <a href={"tel:" + (this.state.conactDetails.contactNumber)} target="_blank" title="Phone Number">
                                                        <Suspense fallback={null}>
                                                            <ImageLoader type="image" src={TEL_IMG}></ImageLoader>
                                                        </Suspense>
                                                        <span>{this.state.conactDetails.contactNumber}</span>
                                                    </a> : null
                                                }
                                                {this.state.conactDetails && this.state.conactDetails.contactEmail ?
                                                    <a href={"mailto:" + (this.state.conactDetails.contactEmail)} target="_blank" title="Email Address">
                                                        <Suspense fallback={null}>
                                                            <ImageLoader type="image" src={EMAIL_IMG}></ImageLoader>
                                                        </Suspense>
                                                        <span>{this.state.conactDetails.contactEmail}</span>
                                                    </a> : null
                                                }
                                                <a className="copyright">
                                                    © {this.state.year} {COMPANY_NAME_FULL}
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-3 col-md-2 powered-by">
                                            <a href={GIVEPLEASE_MICROSITE} target="_blank">
                                                <span>Powered by</span>
                                                {LOGO_GIVEPLEASE}
                                            </a>
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>
                        </div>
                        :
                        <FleckringFooter></FleckringFooter>
                }
            </>
        )
    }
}

export default FooterSection;